import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq-section.component.html',
    styleUrls: ['./faq-section.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class FaqSectionComponent implements OnInit {
  faqs = [{
    title: 'What is the Temenos SaaS Foundation?',
    // eslint-disable-next-line max-len
    content: `
    <p>
      The Temenos SaaS Foundation represents the next generation of software-as-a-service (SaaS) solutions for the banking industry.
    </p>
    <p>For a detailed walkthrough, please watch the video.</p>
    <div class="faq-video-wrapper">
      <video controls>
        <source src="assets/media/client-portal-intro.mp4" type="video/mp4">
        Your browser does not support HTML5 video.
      </video>
    </div>`,
  }, {
    title: 'How do I access the Temenos SaaS Foundation Portal?',
    // eslint-disable-next-line max-len
    content: 'Kindly register using below link and raise Support ticket to get access for Foundation Portal. <a href="https://tcsp-signup.temenos.com/signup/tcsp-signup" target="_blank">https://tcsp-signup.temenos.com/signup/tcsp-signup.</a>',
  }, {
    title: 'What is a Service Definition?',
    // eslint-disable-next-line max-len
    content: 'Service definition is a blueprint that defines the product and capabilities installed on your environment.',
  }, {
    title: 'How do I view Service Definition version details?',
    // eslint-disable-next-line max-len
    content: 'Click the <b>Service Definition</b> menu and click the version name to see version , status, and selected products.',
  }, {
    title: 'What are the types of environments in Temenos SaaS?',
    // eslint-disable-next-line max-len
    content: `
    <table class="faq-table">
      <thead>
        <tr>
          <th>Class</th>
          <th>Typical Use</th>
          <th>HA</th>
          <th>DR</th>
          <th>Scalable</th>
          <th>Data Zone</th>
          <th>Design Time</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>A</td>
          <td>LIVE / DR</td>
          <td>YES</td>
          <td>YES</td>
          <td>YES</td>
          <td>PII</td>
          <td>NO</td>
        </tr>
        <tr>
          <td>B</td>
          <td>PRE-PROD UAT</td>
          <td>YES</td>
          <td>NO</td>
          <td>YES</td>
          <td>PII</td>
          <td>NO</td>
        </tr>
        <tr>
          <td>C</td>
          <td>SIT TESTING</td>
          <td>NO</td>
          <td>NO</td>
          <td>NO</td>
          <td>TEST</td>
          <td>NO</td>
        </tr>
        <tr>
          <td>D</td>
          <td>CONFIG<br>TRAINING<br>SANDBOX</td>
          <td>NO</td>
          <td>NO</td>
          <td>NO</td>
          <td>TEST</td>
          <td>YES</td>
        </tr>
      </tbody>
    </table>
  `,
  }, {
    title: 'What is the Path-to-Live (PTL) workflow?',
    // eslint-disable-next-line max-len
    content: 'It’s a structured process that promotes product changes from development to production with quality control and transparency.',
    }, {
    title: 'What is the difference between Test Data Zone and PII Data Zone?',
    // eslint-disable-next-line max-len
    content: `
    <ul>
      <li><strong>Test Zone:</strong> Used for non-sensitive data and integration testing (Non-Personal Data zone).</li>
      <li><strong>PII Zone:</strong> Used for sensitive customer data with strict security controls (Personal Data zone).</li>
    </ul>`,
    }, {
    title: 'How do I view environment details?',
    // eslint-disable-next-line max-len
    content: 'Click the environment name or the three-dot menu on the Service Definition Summary page to view detail, endpoints and release packages.',
    }, {
    title: 'What are the full forms of the abbreviations RVT and DSF, and what do they represent?',
    // eslint-disable-next-line max-len
    content: `
        <p>
        RVT stands for Release Validation Test. For more details about RVTs refer to <a href="https://saasdocs.temenos.com/saas/docs/services/RVT/RVT/RVT/Release_Validation_Tests.htm#" target="_blank">
        Release Validation Tests</a>.
        </p>
        <p>DSF stands for Design Framework. For more details about DSF refer to <a href="https://docs.temenos.com/docs/Solutions/Technology/Extensibility_Framework/Temenos_Packager/Temenos_Packager/Data_Packager/c_DSF_Packager_Repository.htm#" target="_blank">
        DSF</a>.</p>`
        }, {
    title: 'How do I apply a Release Package and view RVT test results?',
    // eslint-disable-next-line max-len
    content: `
        <p>To apply release, Go to the environment→ <b>Release Package</b> tab → Select package → <b>Apply</b> → Choose to run tests or skip → <b>Submit</b>.
        </p>
        <p>Click the <b>release package name</b> → <b>View Results tab</b> → <b>View test packages</b>, and Karate test reports.</p>
        <p>For a detailed walkthrough, please watch the video.</p>
        <div class="faq-video-wrapper">
          <video controls>
            <source src="assets/media/apply-release-package.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>`
        }, {
    title: 'What should I do if a release package fails to apply?',
    // eslint-disable-next-line max-len
    content: `
      <ol>
        <li>View the DSF error details and do the required changes to build the new package to apply again.</li>
        <li>If the DSF package error is not available, Click the <b>Retry</b> button to reapply the release package.</li>
        <li>Please raise support ticket with environment name, release package details, DSF error details in Temenos Support Ticketing system. 
          <a href="https://itsm-servicedesk.temenos.com/" target="_blank">Click Here</a>.
        </li>
      </ol>
    `,
    }, {
    title: 'How do I get support from Temenos?',
    // eslint-disable-next-line max-len
    content: 'Click the <b>Support</b> button on the Home page to access the Temenos SaaS Ticketing system, and raise a request.',
    }];
  openedIndex: number;

  constructor() { }

  ngOnInit(): void {
  }

  toggleFaq(index: number) {
  if (this.openedIndex === index) {
    this.openedIndex = null;
  } else {
    this.openedIndex = index;
  }
}

}
